/**
 * @generated SignedSource<<881a0a0ae3cc12f967cad58b76a27d7a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UserIntegrationsQuery$variables = {};
export type UserIntegrationsQuery$data = {
  readonly viewer: {
    readonly account: {
      readonly billingAccount: {
        readonly featureAccess: any;
        readonly hasAccessToZapierIntegration: boolean;
      };
      readonly integrations: {
        readonly gsuite: {
          readonly externalId: string;
          readonly id: string;
        } | null;
        readonly hubspot: {
          readonly accountConnected: boolean;
          readonly userConnected: boolean;
        } | null;
        readonly office365: {
          readonly externalId: string;
          readonly id: string;
        } | null;
        readonly slack: {
          readonly botId: string;
          readonly botName: string;
          readonly domain: string | null;
          readonly externalId: string;
          readonly id: string;
          readonly name: string;
        } | null;
      };
      readonly primaryAdmin: {
        readonly fullName: string;
      } | null;
    };
    readonly integrations: {
      readonly asana: {
        readonly email: string;
        readonly id: string;
        readonly isConnected: boolean;
      } | null;
      readonly clickup: {
        readonly id: string;
        readonly isConnected: boolean;
      } | null;
      readonly confluence: {
        readonly id: string;
        readonly isConnected: boolean;
        readonly requiresReconnect: boolean;
        readonly siteName: string;
      } | null;
      readonly google: {
        readonly accountManaged: boolean;
        readonly externalId: string;
        readonly id: string;
        readonly isActive: boolean;
        readonly isGoogleAdmin: boolean;
        readonly name: string;
      } | null;
      readonly hubspot: {
        readonly id: string;
        readonly isConnected: boolean;
      } | null;
      readonly linear: {
        readonly id: string;
        readonly isConnected: boolean;
      } | null;
      readonly microsoftTodo: {
        readonly id: string;
        readonly isConnected: boolean;
      } | null;
      readonly monday: {
        readonly id: string;
        readonly isConnected: boolean;
      } | null;
      readonly mondayOauthClientId: string | null;
      readonly notion: {
        readonly id: string;
        readonly isConnected: boolean;
        readonly siteName: string;
      } | null;
      readonly office365: {
        readonly externalId: string;
        readonly id: string;
        readonly isAdmin: boolean;
      } | null;
      readonly salesforce: {
        readonly id: string;
        readonly isConnected: boolean;
      } | null;
      readonly slack: ReadonlyArray<{
        readonly id: string;
        readonly isConnected: boolean;
        readonly name: string;
      } | null> | null;
      readonly trello: {
        readonly id: string;
        readonly isConnected: boolean;
      } | null;
      readonly zapier: {
        readonly id: string;
        readonly isConnected: boolean;
      } | null;
      readonly zoom: {
        readonly hasLocalRecordingTokenScope: boolean;
        readonly hasRtmsScopes: boolean;
        readonly id: string;
        readonly isConnected: boolean;
        readonly name: string;
      } | null;
    };
    readonly user: {
      readonly internalAttributes: {
        readonly isAccountAdmin: boolean;
      } | null;
    };
  };
};
export type UserIntegrationsQuery = {
  response: UserIntegrationsQuery$data;
  variables: UserIntegrationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAccountAdmin",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalId",
  "storageKey": null
},
v5 = [
  (v1/*: any*/),
  (v2/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "siteName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "UserIntegrations",
  "kind": "LinkedField",
  "name": "integrations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SlackUserNode",
      "kind": "LinkedField",
      "name": "slack",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GoogleUserNode",
      "kind": "LinkedField",
      "name": "google",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v4/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isActive",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGoogleAdmin",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountManaged",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OfficeUserNode",
      "kind": "LinkedField",
      "name": "office365",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAdmin",
          "storageKey": null
        },
        (v4/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ZapierUserNode",
      "kind": "LinkedField",
      "name": "zapier",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AsanaUserNode",
      "kind": "LinkedField",
      "name": "asana",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SalesforceUserNode",
      "kind": "LinkedField",
      "name": "salesforce",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HubspotUserNode",
      "kind": "LinkedField",
      "name": "hubspot",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ZoomUserNode",
      "kind": "LinkedField",
      "name": "zoom",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasLocalRecordingTokenScope",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasRtmsScopes",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ClickupUserNode",
      "kind": "LinkedField",
      "name": "clickup",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TrelloUserNode",
      "kind": "LinkedField",
      "name": "trello",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MondayUserNode",
      "kind": "LinkedField",
      "name": "monday",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mondayOauthClientId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinearUserNode",
      "kind": "LinkedField",
      "name": "linear",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MicrosoftTodoUserNode",
      "kind": "LinkedField",
      "name": "microsoftTodo",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NotionUserNode",
      "kind": "LinkedField",
      "name": "notion",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v6/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ConfluenceUserNode",
      "kind": "LinkedField",
      "name": "confluence",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v6/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiresReconnect",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": "hasAccessToZapierIntegration",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "zapier_integration"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"zapier_integration\")"
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "featureAccess",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "SlackAccountNode",
  "kind": "LinkedField",
  "name": "slack",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "domain",
      "storageKey": null
    },
    (v4/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "botId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "botName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = [
  (v1/*: any*/),
  (v4/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "GSuiteAccountNode",
  "kind": "LinkedField",
  "name": "gsuite",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "OfficeAccountNode",
  "kind": "LinkedField",
  "name": "office365",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountConnected",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userConnected",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserIntegrationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInternalAttributes",
                "kind": "LinkedField",
                "name": "internalAttributes",
                "plural": false,
                "selections": [
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "primaryAdmin",
                "plural": false,
                "selections": [
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HubspotAccountNode",
                    "kind": "LinkedField",
                    "name": "hubspot",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v16/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UserIntegrationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInternalAttributes",
                "kind": "LinkedField",
                "name": "internalAttributes",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "primaryAdmin",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HubspotAccountNode",
                    "kind": "LinkedField",
                    "name": "hubspot",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7fa1334ecd80513402b34824242b273a",
    "id": null,
    "metadata": {},
    "name": "UserIntegrationsQuery",
    "operationKind": "query",
    "text": "query UserIntegrationsQuery {\n  viewer {\n    user {\n      internalAttributes {\n        isAccountAdmin\n        id\n      }\n      id\n    }\n    integrations {\n      slack {\n        id\n        isConnected\n        name\n      }\n      google {\n        id\n        externalId\n        name\n        isActive\n        isGoogleAdmin\n        accountManaged\n      }\n      office365 {\n        id\n        isAdmin\n        externalId\n      }\n      zapier {\n        id\n        isConnected\n      }\n      asana {\n        id\n        isConnected\n        email\n      }\n      salesforce {\n        id\n        isConnected\n      }\n      hubspot {\n        id\n        isConnected\n      }\n      zoom {\n        id\n        isConnected\n        name\n        hasLocalRecordingTokenScope\n        hasRtmsScopes\n      }\n      clickup {\n        id\n        isConnected\n      }\n      trello {\n        id\n        isConnected\n      }\n      monday {\n        id\n        isConnected\n      }\n      mondayOauthClientId\n      linear {\n        id\n        isConnected\n      }\n      microsoftTodo {\n        id\n        isConnected\n      }\n      notion {\n        id\n        isConnected\n        siteName\n      }\n      confluence {\n        id\n        isConnected\n        siteName\n        requiresReconnect\n      }\n    }\n    account {\n      billingAccount {\n        hasAccessToZapierIntegration: hasAccessToFeature(feature: zapier_integration)\n        featureAccess\n        id\n      }\n      primaryAdmin {\n        fullName\n        id\n      }\n      integrations {\n        slack {\n          id\n          domain\n          externalId\n          name\n          botId\n          botName\n        }\n        gsuite {\n          id\n          externalId\n        }\n        office365 {\n          id\n          externalId\n        }\n        hubspot {\n          accountConnected\n          userConnected\n          id\n        }\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ed2df12029121979d942aaf720a8ab7f";

export default node;
